import { IRoutePlanningModel } from 'features/RoutesPlanning/models'
import { IStopFeatureProps, TStopsGeojson } from 'features/RoutesPlanning/types'
import { FeatureCollection, Point } from 'geojson'

type TStopEntity = IStopFeatureProps & { coordinates: number[] }
export const mapRoutesStopsToGeojson = (routes: IRoutePlanningModel[]): TStopsGeojson => {
  const stopsMap = new Map<string, TStopEntity>()
  routes.forEach((route) => {
    const routeColor = route.rgbColor

    route.stops.forEach((stop, stopIndex) => {
      if (!stop.coordinates) return

      const stopKey = `${stop.coordinates.latitude}-${stop.coordinates.longitude}`
      const stopId = stop.id as string
      const stopAddress = `${stop.address?.line1}, ${stop.address?.city}`
      const routeProperty = {
        id: route.id,
        name: route.name || '',
        rgbColor: routeColor,
        stopIndex,
        isOrigin: stopIndex === 0,
        isDestination: stopIndex === route.stops.length - 1,
        stopId,
        stopName: stop.name,
        stopAddress
      }
      if (stopsMap.has(stopKey)) {
        const stopEntity = stopsMap.get(stopKey) as TStopEntity
        stopsMap.set(stopKey, {
          ...stopEntity,
          color: routeColor,
          routes: [...stopEntity.routes, routeProperty]
        })
      } else {
        const stopProperties: TStopEntity = {
          id: stopId,
          coordinates: [parseFloat(stop.coordinates?.longitude || ''), parseFloat(stop.coordinates?.latitude || '')],
          stopIndex,
          color: routeColor,
          isOrigin: stopIndex === 0,
          isDestination: stopIndex === route.stops.length - 1,
          routes: [routeProperty]
        }
        stopsMap.set(stopKey, stopProperties)
      }
    })
  })

  const features: FeatureCollection<Point, IStopFeatureProps>['features'] = []
  stopsMap.forEach((stop) => {
    features.push({
      type: 'Feature' as const,
      geometry: {
        type: 'Point' as const,
        coordinates: stop.coordinates
      },
      properties: {
        id: stop.id,
        stopIndex: stop.stopIndex,
        color: stop.color,
        isOrigin: stop.isOrigin,
        isDestination: stop.isDestination,
        routes: stop.routes
      }
    })
  })

  return {
    type: 'FeatureCollection' as const,
    features
  }
}
